import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";

const GeneralLedgerComponent = loadable(
  () => import("../../components/ServiceReport/LedgerAccount")
);

export default () => {
  return (
    <>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>Service Report</h1>
      </div>
      <GeneralLedgerComponent />
    </>
  );
};
